export default {"src":"/_next/static/media/btn-pinterest.7dd47205.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};